import { MARKETING_RESOURCE_CHANNELS } from "@/services/marketing";
import { RouteRecordRaw } from "vue-router";
export const salesRoutes: RouteRecordRaw[] = [
  {
    path: "spending-report",
    name: "spending-report",
    meta: {
      title: "Spending Report",
      text: "Spending Report",
      description: "See how your spending compares to your budget",
      added: "2021-03-23",
      icon: "money-bill-wave",
      requiredResources: MARKETING_RESOURCE_CHANNELS,
      helpDeskPath: "spending-report",
    },
    component: () => import("@/views/SpendingReport/SpendingReport.vue"),
  },
  {
    path: "budget-tool",
    name: "budget_tool",
    meta: {
      title: "Budget Tool",
      text: "Budget Tool",
      description: "Plan and track your marketing budgets",
      icon: "wallet",
      requiredResources: MARKETING_RESOURCE_CHANNELS,
      requiredFeatureFlag: "budgetTool",
      beta: true,
    },
    component: () => import("@/views/BudgetTool/BudgetTool.vue"),
  },
  {
    path: "budget-tool/:id",
    name: "budget_tool_detail",
    meta: {
      title: "Budget Tool",
      excludeFromNavbar: true,
      requiredFeatureFlag: "budgetTool",
      beta: true,
    },
    component: () => import("@/views/BudgetTool/BudgetPlanDetail.vue"),
  },
];

export const publicBudgetRoute: RouteRecordRaw[] = [
  {
    path: "shared-budget/:token",
    name: "shared_budget",
    meta: {
      title: "Shared Budget",
      includeNavbar: false,
      requiresAuth: false,
      // No requiredFeatureFlag here — the public share endpoint enforces the
      // flag server-side using the plan's org, returning 404 when disabled.
      // A client-side gate would have nowhere to read user/org context from.
    },
    component: () => import("@/views/BudgetTool/SharedBudgetView.vue"),
  },
];
